// Libraries
import { action, computed } from "mobx";

// Custom
import { ColourSelection } from "Custom/Models/ColourSelection";
import { isNullOrUndefined } from "Custom/Utils/Utils";
import { RoofSystemModel } from "Custom/Models/Domain/ProductSelector/SubModels/RoofSystem";

export class ProductsCommonViewModel {
    private model: RoofSystemModel;

    constructor(model: RoofSystemModel) {
        this.model = model;
    }

    // #region Product Properties

    @action
    public setDelcoteBasecoatColour = (selection: ColourSelection): void => {
        this.model.DelcoteProducts.Delcote25Model.basecoatColourSelection = this.model.DelcoteProducts.Delcote25Model.basecoatColours.find((c) => c.value === selection.value);
        this.model.DelcoteProducts.DelcoteAsbestosModel.basecoatColourSelection = this.model.DelcoteProducts.DelcoteAsbestosModel.basecoatColours.find(
            (c) => c.value === selection.value,
        );
    };

    @action
    public setDelcoteTopcoatColour = (selection: ColourSelection): void => {
        this.model.DelcoteProducts.Delcote10Model.setTopcoatColourSelection(this.model.DelcoteProducts.Delcote10Model.topcoatColours.find((c) => c.value === selection.value));
        this.model.DelcoteProducts.Delcote25Model.setTopcoatColourSelection(this.model.DelcoteProducts.Delcote25Model.topcoatColours.find((c) => c.value === selection.value));
        this.model.DelcoteProducts.DelcoteAsbestosModel.setTopcoatColourSelection(
            this.model.DelcoteProducts.DelcoteAsbestosModel.topcoatColours.find((c) => c.value === selection.value),
        );
    };

    @action
    public setDelglazeProductRequired = (value: boolean) => {
        this.model.DelglazeModel.productRequired = value;
    };

    @action
    public setEndlapMeterage = (value: number): void => {
        this.model.DelcoteProducts.Delcote10Model.endlapMeterage = value;
        this.model.DelcoteProducts.Delcote25Model.endlapMeterage = value;
        this.model.SeamsilProducts.Seamsil100Model.endlapMeterage = value;
    };

    @action
    public setFixingCount = (value: number) => {
        this.model.DelcoteProducts.Delcote10Model.fixingCount = value;
        this.model.DelcoteProducts.Delcote25Model.fixingCount = value;
        this.model.DelcoteProducts.DelcoteAsbestosModel.fixingCount = value;
    };

    @action
    public setOverlapMeterage = (value: number): void => {
        this.model.DelcoteProducts.Delcote10Model.overlapMeterage = value;
        this.model.DelcoteProducts.Delcote25Model.overlapMeterage = value;
        this.model.SeamsilProducts.Seamsil100Model.overlapMeterage = value;
    };

    @action
    public setProfileCorrectionPercentage = (value: number): void => {
        this.model.DelcoteProducts.Delcote10Model.profileCorrectionPercentage = value;
        this.model.DelcoteProducts.Delcote25Model.profileCorrectionPercentage = value;
        this.model.DelcoteProducts.DelcoteAsbestosModel.profileCorrectionPercentage = value;
        this.model.SeamsilProducts.Seamsil100Model.profileCorrectionPercentage = value;
        this.model.DelglazeModel.profileCorrectionPercentage = value;
    };

    @action
    public setRidgeFlashingsEtcMeterage = (value: number): void => {
        this.model.DelcoteProducts.Delcote10Model.ridgeFlashingsEtcMeterage = value;
        this.model.DelcoteProducts.Delcote25Model.ridgeFlashingsEtcMeterage = value;
        this.model.SeamsilProducts.Seamsil100Model.ridgeFlashingsEtcMeterage = value;
    };

    @action
    public setRooflightSquareMeterage = (value: number) => {
        this.model.DelcoteProducts.Delcote10Model.rooflightSquareMeterage = value;
        this.model.DelglazeModel.rooflightSquareMeterage = value;
        this.model.DelcoteProducts.Delcote25Model.rooflightSquareMeterage = value;
        this.model.DelcoteProducts.DelcoteAsbestosModel.rooflightSquareMeterage = value;
    };

    @action
    public setRoofSquareMeterage = (value: number) => {
        this.model.DelcoteProducts.Delcote10Model.roofSquareMeterage = value;
        this.model.DelcoteProducts.Delcote25Model.roofSquareMeterage = value;
        this.model.DelcoteProducts.DelcoteAsbestosModel.roofSquareMeterage = value;

        // Be aware of the rooflight area exceeding the roof area.
        if (this.model.DelcoteProducts.Delcote10Model.rooflightSquareMeterage > this.model.DelcoteProducts.Delcote10Model.roofSquareMeterage) {
            this.model.DelcoteProducts.Delcote10Model.rooflightSquareMeterage = this.model.DelcoteProducts.Delcote10Model.roofSquareMeterage;
            this.model.DelglazeModel.rooflightSquareMeterage = this.model.DelcoteProducts.Delcote10Model.roofSquareMeterage;
        }

        if (this.model.DelcoteProducts.Delcote25Model.rooflightSquareMeterage > this.model.DelcoteProducts.Delcote25Model.roofSquareMeterage) {
            this.model.DelcoteProducts.Delcote25Model.rooflightSquareMeterage = this.model.DelcoteProducts.Delcote25Model.roofSquareMeterage;
            this.model.DelglazeModel.rooflightSquareMeterage = this.model.DelcoteProducts.Delcote25Model.roofSquareMeterage;
        }

        if (this.model.DelcoteProducts.DelcoteAsbestosModel.rooflightSquareMeterage > this.model.DelcoteProducts.DelcoteAsbestosModel.roofSquareMeterage) {
            this.model.DelcoteProducts.DelcoteAsbestosModel.rooflightSquareMeterage = this.model.DelcoteProducts.DelcoteAsbestosModel.roofSquareMeterage;
            this.model.DelglazeModel.rooflightSquareMeterage = this.model.DelcoteProducts.DelcoteAsbestosModel.roofSquareMeterage;
        }
    };

    @computed
    public get canDisplayDelglazeRooflightAreaMeterage(): boolean {
        return !isNullOrUndefined(this.model.getProductSelection) && this.model.getProductSelection.value === "id_seamsil";
    }

    // #endregion Product Properties
}
